export default {
    list: {
        title: 'Equipo',
        subtitle: 'Gestiona los miembros del equipo',
        invite: 'Invitar Miembro',
        loading: 'Cargando equipo...',
        addMember: 'Añadir Miembro',
        allRoles: 'Todos los roles',
        allStatuses: 'Todos los estados',
        searchPlaceholder: 'Buscar por nombre o email...',
        rolePlaceholder: 'Filtrar por rol',
        statusPlaceholder: 'Filtrar por estado',
        description: 'Lista de los miembros de tu equipo',
        headers: {
            name: 'Nombre',
            email: 'Email',
            role: 'Rol',
            status: 'Estado',
            lastLogin: 'Último Inicio de Sesión',
            inviteDate: 'Fecha de Invitación',
            actions: 'Acciones',
        },
        noMembers: {
            title: 'No se encontraron miembros del equipo',
            message: 'Intenta modificar los filtros de búsqueda',
            emptyMessage: 'Comienza añadiendo tu primer miembro del equipo',
            addFirst: 'Añadir Primer Miembro',
        },
        modal: {
            addTitle: 'Invitar Miembro',
            editTitle: 'Editar Miembro',
            removeTitle: 'Eliminar Miembro',
            fields: {
                name: 'Nombre',
                namePlaceholder: 'Ingresa nombre',
                email: 'Email',
                emailPlaceholder: 'nombre@empresa.com',
                firstName: 'Nombre',
                firstNamePlaceholder: 'Ingresa nombre',
                lastName: 'Apellido',
                lastNamePlaceholder: 'Ingresa apellido',
                role: 'Rol',
                rolePlaceholder: 'Selecciona rol',
                status: 'Estado',
                statusPlaceholder: 'Selecciona estado',
                isActive: 'Activo',
            },
            roles: {
                operator: 'Operador',
                companyAdmin: 'Admin',
            },
            cancel: 'Cancelar',
            save: 'Guardar',
            create: 'Crear',
            invite: 'Enviar Invitación',
            confirmRemove: 'Eliminar Miembro',
            removeConfirmation: '¿Estás seguro de que quieres eliminar a {{name}} ({{email}}) del equipo? Esta acción no se puede deshacer.',
            sendNotificationEmail: 'Enviar email de notificación al usuario',
            success: {
                memberInvited: 'Invitación enviada con éxito',
                memberUpdated: 'Miembro actualizado con éxito',
                memberRemoved: 'Miembro eliminado con éxito',
            },
            error: {
                emailRequired: 'El email es obligatorio',
                invitingMember: 'Error al invitar al miembro',
                updatingMember: 'Error al actualizar al miembro',
                removingMember: 'Error al eliminar al miembro',
            },
        },
        statusLabels: {
            active: 'Activo',
            inactive: 'Inactivo',
        },
        actions: {
            edit: 'Editar',
            remove: 'Eliminar',
        },
        never: 'Nunca',
        confirmDelete: '¿Estás seguro de que quieres eliminar este miembro del equipo?',
    },
};
